import React, { JSX, useEffect, useState } from 'react';
import './OrderTracking.css';
import Footer from '../Footer/Footer';
import { FaBox, FaTruck, FaCheckCircle, FaShoppingCart } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getStoredAuth } from '../../StoreData/authUser';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../App/store';

interface Step {
    title: string;
    date: string;
    icon: JSX.Element;
}

const OrderTracking: React.FC = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const state = location.state;

    const { PosCustomerDetails } = useSelector((state: any) => state.pos)



  

    const [filledHeight, setFilledHeight] = useState(0);
    const [Addresscustomer, setAddressCustomer] = useState<string>("")

    const determineSteps = (mode: string): Step[] => {
        const status = mode?.toLowerCase();

        const baseSteps: Step[] = [
            {
                title: 'Order Placed',
                date: state?.OrderDate?.split('T')[0] || '',
                icon: <FaShoppingCart />,
            },
            {
                title: 'Processed',
                date: '',
                icon: <FaBox />,
            },
            {
                title: 'Shipped',
                date: state?.orderdespatchdate?.split('T')[0] || '',
                icon: <FaTruck />,
            },
            {
                title: 'Delivered',
                date: '',
                icon: <FaCheckCircle />,
            },
        ];

        if (status === 'online') {
            baseSteps[2].title = 'Online Processing';
        } else if (status === 'dispatched') {
            baseSteps[2].title = 'Dispatched';
        } else if (status === 'cancelled') {
            baseSteps[2].title = 'Cancelled';
            baseSteps[3].title = '';
        }

        return baseSteps;
    };

    const steps = determineSteps(state?.OrderMode || '');


    
    const currentIndex = Math.max(
        steps.findIndex(
            (step) =>
                step.title.toLowerCase() === state?.OrderMode?.toLowerCase()
        ),
        0
    );

    useEffect(() => {
        const percent = (currentIndex + 1) / steps.length;
        setFilledHeight(percent * 100);
    }, [currentIndex]);

    useEffect(() => {
        const storedAuth = getStoredAuth();

        if (!storedAuth) {
            navigate('/');
            return;
        }

        try {
            const parsed = JSON.parse(storedAuth);
            const user = parsed[0];

            if (!user || !user.mid) {
                navigate('/');
            }

            setAddressCustomer(user?.address)
        } catch (error) {
            console.error("Failed to parse auth data:", error);
            navigate('/');
        }
    }, [navigate]);





    return (
        <div className="design-root">
            <div className="layout-container">
                <header>
                    <button className="back-btn" style={{ marginLeft: '20px' }} onClick={() => window.history.back()}>
                        ← Back to Shop
                    </button>
                </header>

                <main className="content">
                    <div className="page-title">Track Your Order</div>



                    <div className="status-plus-image">
                        <section className="order-status">
                            <h2>Order Status</h2>
                            <div className="status-grid">
                                <div className="status-fill" style={{ height: `${filledHeight}%` }} />
                                {steps.map((step, index) => (
                                    <div key={index} className="status-step">
                                        <div
                                            className={`icon-line ${index <= currentIndex ? 'active' : ''} ${index === currentIndex ? 'current' : ''}`}
                                        >
                                            {step.icon}
                                        </div>
                                        <div className="status-text">
                                            <p className="step-title">{step.title}</p>
                                            <p className="step-date">{step.date}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>

                        {/* <aside className="product-info">
              <img
                src={'https://via.placeholder.com/120'} // Optional: you can replace this with actual product image if available
                alt={state?.itemname}
              />
              <p className="product-name">{state?.itemname}</p>
            </aside> */}
                    </div>

                    <section className="delivery-info">
                        <h2>Delivery Information</h2>
                        <div className="info-grid">
                            <div className="info-row">
                                <span>Estimated Delivery</span>
                                <span>{state?.orderdespatchdate?.split('T')[0] || 'N/A'}</span>
                            </div>
                            <div className="info-row">
                                <span>Delivery Address</span>
                                <span>{Addresscustomer}</span> {/* Replace with actual delivery address if available */}
                            </div>
                            {/* <div className="info-row">
                                <span>Delivery Preferences</span>
                                <span>Change Address / Reschedule</span>
                            </div> */}
                        </div>
                    </section>

                    <section className="order-details">
                        <h2>Order Details</h2>
                        <table className="order-table">
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Quantity</th>
                                    <th>Selling Price</th>
                                    <th>MRP</th>
                                    <th>Discount</th>
                                    <th>Tax</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {state?.items?.map((item: any, index: number) => (
                                    <tr key={index}>
                                        <td data-label="Item">{item.itemname}</td>
                                        <td data-label="Quantity">{item.ItemQty}</td>
                                        <td data-label="Selling Price">₹{item.ItemSellingprice}</td>
                                        <td data-label="MRP">₹{item.ItemMrp}</td>
                                        <td data-label="Discount">₹{item.discountamount}</td>
                                        <td data-label="Tax">₹{item.Taxvalue}</td>
                                        <td data-label="Amount">₹{item.orderamount}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="action-buttons">
                            <Link to="/">
                                <button className="shop-btn">Return to Shop</button>
                            </Link>
                            <Link to="/orders">
                                <button className="details-btn">View Order Details</button>
                            </Link>
                        </div>

                        <p className="support-note">If you have any questions, please contact our support team.</p>
                    </section>
                </main>
            </div>
            <Footer />
        </div>
    );
};

export default OrderTracking;
